module.exports = __webpack_public_path__ + "img/IEEE_TIM_2023.0f1c9ff3.png";